'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
* Comparison algorithm to prevent timing attacks.
* See: https://en.wikipedia.org/wiki/Timing_attack
* @param {String} v1 - The first value to compare
* @param {String} v2 - The second value to compare
* @return {boolean} True if the strings are equivalent, false otherwise.
*/
function fixedTimeCompare(v1, v2) {
  var compare = function compare(value, current, index) {
    return value | v1.charCodeAt(index) ^ v2.charCodeAt(index);
  };

  return v1.split('').reduce(compare, v1.length ^ v2.length) < 1;
}

exports.fixedTimeCompare = fixedTimeCompare;


//////////////////
// WEBPACK FOOTER
// ./node_modules/xfc/lib/lib/string.js
// module id = 154
// module chunks = 0